import { parsePostContent } from '@src/model/upvote/helpers';
import type { Post } from '@src/store/contentEntities/model';
import { getMainImageFromBlocks } from '@src/utils/editorjs-utils/editorjs-utils';

export type PostImageType = 'hero' | 'featured';
export function getPostImageUrl(post: Post, imageType: PostImageType = 'featured') {
    const imageUrl = imageType === 'hero' ? getHeroImage(post) : getFeaturedImage(post);
    if (!imageUrl) return getMainImageFromBlocks(parsePostContent(post)?.blocks || []);
    return imageUrl;
}

export function getFeaturedImage(post: Post) {
    return post.featuredImage || post.heroImage;
}

export function getHeroImage(post: Post) {
    return post.heroImage || post.featuredImage;
}
